import { defineMessages } from 'react-intl';

export default defineMessages({
    currentBalance: {
        id: '_.single_provider_account.current_balance',
        defaultMessage: 'Current balance'
    }
});
